import { useState } from "react";

export default function Login({ onLogin }) {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, password })
      });

      if (!res.ok) throw new Error('Invalid credentials');

      const data = await res.json();
      onLogin(data);

    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
      <form
        onSubmit={handleSubmit}
        autoComplete="on"
        className="card p-4 shadow"
        style={{ width: '320px' }}
      >
        <h3 className="mb-3 text-center">Login</h3>
        {error && <div className="alert alert-danger">{error}</div>}

        <div className="mb-3">
          <label htmlFor="username" className="form-label">Username</label>
          <input
            id="username"
            name="username"
            type="text"
            autoComplete="username"
            spellCheck={false}
            autoCapitalize="none"
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="current-password" className="form-label">Password</label>
          <input
            id="current-password"
            name="password"
            type="password"
            autoComplete="current-password"
            className="form-control"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-success w-100">Log in</button>
      </form>
    </div>
  );
}